module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/how-to-enjoy-sola-04-ce79c4235da8e8619ec8c805a10aebd9.jpg";